export default __webpack_public_path__ + "static/media/img10.14bfd175.png";